import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserState } from '../../states/user-state';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private userState: UserState) {
    }

    canActivate(): boolean {
        // return true; // bypass for now
        if (!this.userState.getAuthenticated()) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}
